<template>
  <div>
    <Form label-position="top" class="pd-r-5 pd-l-5">
      <FormItem label="Огноо эхлэх">
        <DatePicker
          type="datetime"
          v-model="srch.startDate"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
          placeholder="сонгоно уу"
          class="w-full"
        ></DatePicker>
      </FormItem>
      <FormItem label="Огноо дууусах">
        <DatePicker
          type="datetime"
          v-model="srch.endDate"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
          placeholder="сонгоно уу"
          class="w-full"
        ></DatePicker>
      </FormItem>
    </Form>
    <hr class="m-t-sm m-b-sm" />
    <div class="pd-l-5 pd-r-5">
      <Button
        @click="$emit('on-seach', srch)"
        icon="md-refresh"
        long
        type="primary"
        >Ачааллах</Button
      >
    </div>
  </div>
</template>

<script>
var _ = require("lodash");

import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  //Input,
  FormItem,
  DatePicker,
  Button
  //Notification
  //Checkbox,
  //RadioGroup,
  //Radio
} from "element-ui";

export default {
  components: {
    Form,
    //Input,
    FormItem,
    DatePicker,

    Button
  },
  data() {
    return {
      srch: {
        id: null,
        p2: "",
        startDate: null,
        endDate: null
      },
      coreSearchModel: {},
      filterData: {
        tasks: []
      }
    };
  },
  methods: {},
  mounted() {}
};
</script>
